var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearable-input"},[_c('b-form-input',_vm._b({attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'b-form-input',_vm.$attrs,false)),_vm._v(" "),(_vm.value)?_c('span',{staticClass:"clearable-input__clear",on:{"click":function($event){return _vm.$emit('input', '')}}},[_vm._v("×")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc32c93e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ClearableInput.vue
// module id = 819
// module chunks = 0